import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import * as HeApi from '../HeApi';
import * as PATH from '../../../lib/routes/path';

import WithLoading from '../../../Hoc/WithLoading';
import HeRecordingView from './HeRecordingView';

const HeRecording = ({ match }) => {
  const barcodeId = match.params.barcodeId || localStorage.getItem("he_recording_barcodeId");

  const history = useHistory();
  const location = useLocation();
  const { validated } = location.state || {};
  const [ isValidated, setIsValidated ] = useState(validated || false);
  const getRecodings = useMemo(() => `/he/recording/barcode/${barcodeId}`, [barcodeId]);

  useEffect(() => {
    // If not coming from a validated session, verify the barcode
    if (!isValidated) {
      // If the stored barcode doesn't match the URL barcode or doesn't exist,
      // redirect to barcode scan page
      if (!barcodeId) {
        window.alert("바코드가 없습니다.\n바코드를 다시 한번 확인해 주시기 바랍니다.");
        history.push(`${PATH.HE_RECORDING_BARCODE}`);
        return;
      }
      
      // Validate the barcode
      HeApi.validateBarcode({ barcodeId }).then(response => {
        if (!response.data.valid) {
          // If invalid, redirect to barcode entry
          window.alert("유효하지 않은 바코드입니다.\n바코드 숫자가 올바른지 다시 한번 확인해 주시기 바랍니다.");
          localStorage.removeItem("he_recording_barcodeId");
          history.push(`${PATH.HE_RECORDING}`);
          return;
        }
        
        if (!response.data.userAgree) {
          // If not agreed to privacy policy, redirect to consent page
          history.push(`${PATH.HE_RECORDING_BARCODE}/${barcodeId}/privacy-consent`);
          return;
        }
        
        // If we get here, the barcode is valid and user has agreed to terms
        setIsValidated(true);
      }).catch(() => {
        // On error, redirect to barcode entry
        window.alert("바코드 조회 중 오류가 발생하였습니다.\n다시 한번 시도해 주시기 바랍니다.");
        localStorage.removeItem("he_recording_barcodeId");
        history.push(`${PATH.HE_RECORDING}`);
        return;
      });
      
      localStorage.setItem("he_recording_barcodeId", barcodeId);
    }
  }, [barcodeId, validated, history]);

  return <>
    { isValidated && 
      <WithLoading
        component={HeRecordingView}
        url={getRecodings}
        onlyLoader
      />
    }
    </>
  ;
};

export default React.memo(HeRecording);